import { GlobalConfig } from 'ngx-toastr';
import { BackofficeToastComponent } from './backoffice-toast.component';

export const BACKOFFICE_TOAST_CONFIG: Partial<GlobalConfig> = {
  timeOut: 10000,
  positionClass: 'bo-toast-position',
  toastComponent: BackofficeToastComponent,
  toastClass: 'bo-feedback bo-toast',
  extendedTimeOut: 3000,
  easeTime: 180,
  progressBar: true,
  tapToDismiss: false,
  maxOpened: 3,
  preventDuplicates: true,
  closeButton: true,
  iconClasses: {
    error: 'toast-error',
    info: 'toast-info',
    success: 'toast-success',
    warning: 'toast-warning',
  },
};
